import {
  selectBuildingsDamage,
  selectCitiesCache,
  selectCurrentPlayer,
  selectFortressesUnderConstruction,
  selectGoblinsTraps,
  selectHexes,
  selectPlayers,
  selectSpecialBuildings,
  selectUnits
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {goblinsDamageBuilding, goblinsRemoveTrap, goblinsSetTrap, succubesSeduceUnit} from "../../../redux/actions";
import {GOBLINS_ABILITY_SUCCESS_THRESHOLD} from "../../../configs/factions/goblins";
import {ID_PREFIX_FOR_GOBLINS_TRAP} from "../../../constants/ids";
import {getD20Roll} from "../../dice/getD20Roll";
import {getD6Roll} from "../../dice/getD6Roll";
import {getBotD6MinRoll} from "../../dice/getBotD6MinRoll";
import {createRandomId} from "../../ids/createRandomId";
import {checkIfFinalRound} from "../../checkIfFinalRound";
import {calculateSeductionSuccess} from "../../factions/succubes/calculateSeductionSuccess";
import {calculateGoblinsBuildingDamageOutcome} from "../../factions/goblins/calculateGoblinsBuildingDamageOutcome";
import {isPreW39FactionPlayer} from "../abTestGates";
import {pickW39SeductionAttempt} from "../factions/succubesBot";
import {pickW39GoblinsAbility, W39_GOBLINS_ABILITIES} from "../factions/goblinsBot";

/**
 * Этап способностей фазы войны (волна 39): одно действие за тик — соблазнение
 * суккубов или способность гоблинов, та, что дает большую ожидаемую ценность.
 * Экшены и броски — те же, что у живого игрока (GameScene.handleAbilitiesPhaseClick).
 * Способность — фракционная по ОТРЯДУ: соблазненный отряд гоблинов у суккубов
 * сохраняет свои способности. Legacy-игрок волны 39 (isPreW39FactionPlayer)
 * этап пропускает, как до волны. Возвращает true, если действие совершено
 */
export const decideAbilitiesStep = (store) => {
  const state = store.getState();
  const currentPlayer = selectCurrentPlayer(state);
  if (!currentPlayer || isPreW39FactionPlayer(currentPlayer.id)) {
    return false;
  }

  const input = {
    player: currentPlayer,
    players: selectPlayers(state),
    units: selectUnits(state),
    hexes: selectHexes(state),
    citiesCache: selectCitiesCache(state),
    specialBuildings: selectSpecialBuildings(state),
    buildingsDamage: selectBuildingsDamage(state),
    fortressesUnderConstruction: selectFortressesUnderConstruction(state),
    goblinsTraps: selectGoblinsTraps(state),
    isFinalRound: checkIfFinalRound(state),
  };

  const seduction = pickW39SeductionAttempt(input);
  const goblinsAbility = pickW39GoblinsAbility(input);

  if (seduction && (!goblinsAbility || seduction.expectedValue >= goblinsAbility.expectedValue)) {
    const {unit, target} = seduction;
    const roll = getD20Roll();
    const success = calculateSeductionSuccess(roll, unit.size, target.size);
    store.dispatch(succubesSeduceUnit(unit.id, target.id, target.ownerId, roll, unit.size, target.size, success));
    return true;
  }

  if (!goblinsAbility) {
    return false;
  }

  const {type, unit, hexKey} = goblinsAbility;
  if (type === W39_GOBLINS_ABILITIES.DAMAGE_BUILDING) {
    const victim = goblinsAbility.victim;
    const roll = getD6Roll(getBotD6MinRoll(currentPlayer, victim ? [victim] : []));
    const success = roll >= GOBLINS_ABILITY_SUCCESS_THRESHOLD;
    const outcome = success
      ? calculateGoblinsBuildingDamageOutcome(input.hexes, input.specialBuildings, input.buildingsDamage, hexKey, roll)
      : null;
    store.dispatch(goblinsDamageBuilding(unit.id, hexKey, roll, success, outcome, victim?.id || null));
    return true;
  }
  if (type === W39_GOBLINS_ABILITIES.SET_TRAP) {
    const roll = getD6Roll();
    const success = roll >= GOBLINS_ABILITY_SUCCESS_THRESHOLD;
    store.dispatch(goblinsSetTrap(unit.id, createRandomId(ID_PREFIX_FOR_GOBLINS_TRAP), hexKey, roll, success));
    return true;
  }
  if (type === W39_GOBLINS_ABILITIES.REMOVE_TRAP) {
    store.dispatch(goblinsRemoveTrap(unit.id, goblinsAbility.trapId));
    return true;
  }
  return false;
};
